import React, {Component} from 'react';
import {Div, Spinner, Title} from '@vkontakte/vkui';
import PhotoGallery from './PhotoGallery';
import SalePointsApi from '../api/references/salePoints';

/**
 * Отображает фотогалереи из мониторинговых документов ТТ, сгруппированные по дате.
 * Props: sp_id (number), base_url (string).
 * Тихо игнорирует ошибку — пока бэкенд не готов, блок просто не рендерится.
 */
class SalePointMonitoringGalleries extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            groups: [],
        };
    }

    componentDidMount() {
        this.loadGalleries();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.sp_id !== this.props.sp_id) {
            this.loadGalleries();
        }
    }

    loadGalleries = () => {
        const {sp_id} = this.props;
        if (!sp_id || sp_id <= 0) {
            return;
        }
        this.setState({loading: true, groups: []});
        SalePointsApi.getMonitoringGalleries(sp_id)
            .then((res) => {
                const results = (res && res.data && Array.isArray(res.data.results))
                    ? res.data.results
                    : [];
                const groups = results.filter((g) => {
                    if (!g || !g.images) return false;
                    const keys = Object.keys(g.images);
                    return keys.some((k) => g.images[k] && g.images[k].hasImage);
                });
                this.setState({loading: false, groups});
            })
            .catch(() => {
                this.setState({loading: false, groups: []});
            });
    }

    render() {
        const {base_url} = this.props;
        const {loading, groups} = this.state;

        if (loading) {
            return (
                <Div style={{display: 'flex', alignItems: 'center', gap: 8, padding: '8px 16px'}}>
                    <Spinner size="small"/>
                    <span style={{fontSize: 13, color: 'var(--vkui--color_text_secondary)'}}>
                        Загрузка фото мониторингов…
                    </span>
                </Div>
            );
        }

        if (!groups.length) {
            return null;
        }

        return (
            <div>
                <Div>
                    <Title level="2">Фотографии мониторингов</Title>
                </Div>
                {groups.map((group) => {
                    const label = [
                        group.date ? `Дата мониторинга: ${group.date}` : null,
                        group.user_name ? group.user_name : null,
                        group.comment ? group.comment : null,
                    ].filter(Boolean).join(' — ');

                    return (
                        <div key={group.doc_id}>
                            <Div style={{paddingBottom: 0}}>
                                <span style={{
                                    fontWeight: 500,
                                    fontSize: 14,
                                    color: 'var(--vkui--color_text_primary)',
                                }}>
                                    {label}
                                </span>
                            </Div>
                            <PhotoGallery
                                images={group.images}
                                title=""
                                base_url={base_url}
                                readOnly={true}
                                fancyboxGroup={`monGal-${group.doc_id}`}
                                emptyMessage=""
                                showAddButton={false}
                            />
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default SalePointMonitoringGalleries;
